import { useMutation } from '@apollo/client';
import {
  RepublishEstateMutation,
  RepublishEstateMutationActions,
  RepublishEstateT,
  REPUBLISH_ESTATE,
} from '@contexts/Estate';
import { ResponseApolloErrorMapping } from '@shared/data-mappers';
import { RepublishEstateRequestDto, RepublishEstateResponseDto } from '../dtos';

export const GqlRepublishEstateMutationActions: RepublishEstateMutationActions = {
  useRepublishEstate: (): RepublishEstateT => {
    const [action, { data, loading, error }] = useMutation<RepublishEstateResponseDto, RepublishEstateRequestDto>(
      REPUBLISH_ESTATE,
      {
        errorPolicy: 'all',
      }
    );

    return {
      loading,
      error: error && ResponseApolloErrorMapping(error),
      republishedEstate: data?.republishEstate,
      republishEstate: (mutation: RepublishEstateMutation) =>
        action({
          variables: {
            ...mutation,
          },
        }),
    };
  },
};
